import React from 'react';

import { RefinementListPanelProps } from '@white-nl/instantsearch-components/dist/types/components';
import RefinementList from '../RefinementList';
import CollapsiblePanel from '../../utils/CollapsiblePanel';

export default function RefinementListPanel({
  results,
  refinementList,
  refinementListSettings,
  additionalData,
}: RefinementListPanelProps) {
  const { canRefine } = refinementList;

  const { panelSettings } = refinementListSettings;

  if (panelSettings?.hideIfEmpty && (!canRefine || refinementList.items.length < 2)) {
    return null;
  }

  return (
    <CollapsiblePanel
      collapsiblePanelSettings={panelSettings?.collapsiblePanelSettings}
      header={panelSettings?.header}
      footer={panelSettings?.footer}
    >
      <RefinementList
        results={results}
        refinementList={refinementList}
        refinementListSettings={refinementListSettings}
        additionalData={additionalData}
      />
    </CollapsiblePanel>
  );
}
